export default __webpack_public_path__ + "static/media/RobertDTestimonial.bd6673ef.png";